let facility = {
    name: ''
};

export default facility;